import React, { useEffect, useState, useRef } from "react";
// import {
//   FaHeart,
//   FaRegComment,
//   FaEye,
// } from "react-icons/fa";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { marked } from "marked";
import { Modal, Button, Form } from "react-bootstrap";

import "./home.css";
import HoroscopeList from "../features/horoscope/HoroscopeList";
import HomeSlider from "../components/slider/homeSlider";
import SidebarOptions from "../components/slider/SidebarOptions";
import AstrologerSlider from "../components/slider/AstrologerSlider";
import Testimonial from "../components/Testimonial/testimonial";
import FaQ from "../features/FaQ/faq";
import Plan from "../features/plan/plan";

// Icon imports (used in commented features section)
// import ConnectIcon from "../assets/image/connect.png";
// import CalendarIcon from "../assets/image/calender (2).png";
// import ShopIcon from "../assets/image/shop.png";
// import PoojaIcon from "../assets/image/puja.png";

function Home() {
  const [current, setCurrent] = useState(0);
  const [images, setImages] = useState([]);
  const [images3, setImages3] = useState([]);
  const [current3, setCurrent3] = useState(0);
  const [paymentPopup, setPaymentPopup] = useState(null);
  const sliderRef = useRef(null);

  const [recentBlogs, setRecentBlogs] = useState([]);
  const baseImagePath = "https://dashboard.jyotirvani.com/uploads/blog/";

  const [homams, setHomams] = useState([]);

  // Modal and form state
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    dateOfBirth: "",
    timeOfBirth: "",
    placeOfBirth: "",
    contactNumber: "",
  });

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const message = `🌠✨ TEAM Jyotirvani 🌠✨
Your Gateway to Cosmic Clarity

🙏 Thank you for trusting us with your astrological journey.
To help us connect you with our Certified & Trusted Astrologer, please share the following birth details:

✅ Full Name: ${formData.fullName}
📅 Date of Birth (DD/MM/YYYY): ${formData.dateOfBirth}
⏰ Time of Birth (AM/PM): ${formData.timeOfBirth}
📍 Place of Birth (City, State, Country): ${formData.placeOfBirth}
📱 Contact Number (WhatsApp preferred): ${formData.contactNumber}

Once we receive your details, our team will schedule your personalized session and reach out to you shortly.

Please note: Each consultation is carefully crafted to ensure accuracy, depth, and insight based on your unique planetary blueprint.

Let the stars guide you…
– Team Jyotirvani
Illuminate Your Life with Divine Wisdom ✨🌞⛔`;

    const whatsappUrl = `https://wa.me/919616339090?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");

    // Reset form and close modal
    setFormData({
      fullName: "",
      dateOfBirth: "",
      timeOfBirth: "",
      placeOfBirth: "",
      contactNumber: "",
    });
    setShowModal(false);
  };

  // --------bannerHeading-----------
  useEffect(() => {
    fetch("https://jyotirvani.onrender.com/cosmic_guide")
      .then((res) => res.json())
      .then((data) => {
        // Ensure the API returns an array with expected keys
        // Data is fetched but not currently displayed
        console.log("Cosmic guide data:", data);
      })
      .catch((error) =>
        console.error("Error fetching cosmic guide data:", error),
      );
  }, []);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(
          "https://dashboard.jyotirvani.com/api/Secondhomebanner",
        );
        const result = await response.json();
        if (result.status && Array.isArray(result.data)) {
          const basePath =
            "https://dashboard.jyotirvani.com/uploads/secondbanner/";
          const imageUrls = result.data.map(
            (item) => `${basePath}${item.banner}`,
          );
          setImages(imageUrls);
        }
      } catch (error) {
        console.error("Failed to fetch banners:", error);
      }
    };

    fetchBanners();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearTimeout(timeout);
  }, [current, images.length]);

  // Fetch banners from the API
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch(
          "https://dashboard.jyotirvani.com/api/homeBanner",
        );
        const result = await response.json();
        if (result.status && Array.isArray(result.data)) {
          const basePath = "https://dashboard.jyotirvani.com/uploads/banner/";
          const imageUrls = result.data.map(
            (item) => `${basePath}${item.banner}`,
          );
          setImages3(imageUrls);
        }
      } catch (error) {
        console.error("Failed to fetch banners:", error);
      }
    };

    fetchBanners();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent3((prev) => (prev + 1) % images3.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images3]);
  // start Homan data
  useEffect(() => {
    fetch("https://dashboard.jyotirvani.com/api/pujolist")
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          const basePath =
            "https://dashboard.jyotirvani.com/uploads/pujobanner/";
          const formattedData = data.data.map((item) => ({
            id: item.id,
            pujaName: item.title,
            image: basePath + item.image,
            description: item.description, // ✅ add this
            price: item.price,
            category: "", // optionally use item.category if available
          }));
          setHomams(formattedData);
        }
      })
      .catch((error) => console.error("Error fetching homams:", error));
  }, []);

  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const payment = params.get("payment");
  const orderId = params.get("order_id");

const returnType = params.get("return_type");

if (returnType === "plan") {

  if (payment === "success") {
    setPaymentPopup({
      type: "success",
      title: "Plan Payment Successful!",
      message: `Your plan purchase is completed successfully. Order ID: ${orderId}`,
    });
  }

  if (payment === "failed") {
    setPaymentPopup({
      type: "failed",
      title: "Plan Payment Failed!",
      message: "Your payment was not completed. Please try again.",
    });
  }

}

  if (payment) {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}, []);

  // const toggleDescription = (id) => {
  //   setExpandedId((prevId) => (prevId === id ? null : id));
  // };

  const createMarkup = (htmlText) => {
    return { __html: DOMPurify.sanitize(marked.parse(htmlText || "")) };
  };

  // Auto slide effect
  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const slideInterval = setInterval(() => {
      if (slider) {
        scrollAmount += 320;
        if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
          scrollAmount = 0;
        }
        slider.scrollTo({ left: scrollAmount, behavior: "smooth" });
      }
    }, 5000);

    return () => clearInterval(slideInterval);
  }, []);

  // end Homan data

  // Features configuration (used in commented section - commented out for now)
  /*
  const features = [
    {
      icon: ConnectIcon,
      label: "Connect with Astrologer",
      route: "/AstrologerSection",
    },
    {
      icon: CalendarIcon,
      label: "Hindu panchang",
      route: "/FastivelCalander",
    },
    {
      icon: ShopIcon,
      label: "Jyotirvani Shop",
      route: "/ShopCategoryCard",
    },
    {
      icon: PoojaIcon,
      label: "Book A Puja",
      route: "/Homan",
    },
  ];
  */

  //blog api

  useEffect(() => {
    const fetchRecentBlogs = async () => {
      try {
        const res = await fetch(
          "https://dashboard.jyotirvani.com/api/fetchblog",
        );
        const data = await res.json();
        if (data.status && Array.isArray(data.data)) {
          const sorted = [...data.data].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          );
          setRecentBlogs(sorted.slice(0, 3)); // show only top 3 blogs
        } else {
          console.error("Invalid API response:", data.message);
        }
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchRecentBlogs();
  }, []);
  //end blog api

  return (
    <div className="ra-home-main-div">
      {paymentPopup && (
  <div className="payment-home-popup-overlay">
    <div className={`payment-home-popup-box ${paymentPopup.type}`}>
      <button
        className="payment-home-popup-close"
        onClick={() => setPaymentPopup(null)}
      >
        ×
      </button>

      <div className="payment-home-popup-icon">
        {paymentPopup.type === "success" ? "✓" : "!"}
      </div>

      <h2>{paymentPopup.title}</h2>

      <p>{paymentPopup.message}</p>

      <button
        className="payment-home-popup-btn"
        onClick={() => setPaymentPopup(null)}
      >
        Okay
      </button>
    </div>
  </div>
)}
      <div className="ra-home-main-part">
        <div className="ra-home-big-part1-img">
          <div className="ra-home-big-banner-slider">
            <div className="ra-home-big-banner-slide-wrapper">
              {images3.map((src, i) => (
                <div
                  key={i}
                  className={`ra-home-big-banner-slide ${
                    i === current3 ? "active" : ""
                  }`}
                >
                  <img src={src} alt={`Slide ${i + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="ra-home-part1">
          <div className="row">
            <div className="col-md-6">
              <div className="ra-home-part1-text">
                <h2 className="ra-home-2nd">
                  Welcome to Your True Cosmic Guide — Experience the Power of
                  Vedic Astrology
                </h2>
                <h3>
                  Ancient Wisdom. Modern Clarity Are you feeling stuck — in your
                  relationships, career, health, or life direction? Do you find
                  yourself asking, “Why is this happening to me?” or “When will
                  things get better?”
                </h3>
                <p className="ra-home-ist">
                  At jyotirvani.com, we blend the sacred science of Vedic
                  Astrology with a compassionate, modern approach — offering
                  insights that not only decode your past but also empower your
                  future.
                </p>
                <div className="ra-box-btn">
                  <button type="button" onClick={handleModalShow}>
                    Book Your Session
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ra-home-part1-img">
                <div className="ra-home-banner-slider">
                  <div
                    className="ra-home-banner-slide-wrapper"
                    style={{
                      transform: `translateX(-${current * 100}%)`,
                      transition: "transform 0.5s ease-in-out",
                      display: "flex",
                      //
                    }}
                  >
                    {images.map((src, i) => (
                      <div
                        key={i}
                        className="ra-home-banner-slide"
                        style={{ flex: "0 0 100%" }}
                      >
                        <img src={src} alt={`Slide ${i + 1}`} />
                      </div>
                    ))}
                  </div>

                  <div className="ra-home-banner-dot">
                    {images.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === current ? "active" : ""}`}
                        onClick={() => setCurrent(i)}
                      ></span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="container">
          <div className="ra-home-part2">
            <div className="row">
              {features.map((item, index) => (
                <div
                  className="col-md-3"
                  key={index}
                  onClick={() => navigate(item.route)}
                >
                  <div className="ra-home-part2-main-box">
                    <div className="ra-home-part2-feature-box">
                      <div
                        className="ra-home-part2-feature-icon"
                        style={{ backgroundColor: item.color }}
                      >
                        <img src={item.icon} alt={item.label} />
                      </div>
                      <p>{item.label}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <SidebarOptions />
      </div>
      {/* Horoscope Section */}
      <HoroscopeList />
      <div className="home-recent-blogs">
        <div className="container">
          <h2 className="home-blog-title">
            Our <span>Blog</span>
          </h2>
          <p className="ra-home-blog-description">
            "Jyotirvani" is your gateway to uncovering the profound wisdom
            hidden within the Vedas, Upanishads, and Puranas. Through its
            insightful blogs, it reveals the deeper meanings behind festivals,
            sacred dates, and traditional beliefs. Embark on a journey of
            spiritual discovery—join Sanatan Jyoti today and enrich your
            understanding of Sanatan Dharma.
          </p>

          <div className="blog-row">
            {recentBlogs.map((blog) => (
              <div key={blog.id} className="blog-col">
                <div className="blog-card">
                  <img
                    src={`${baseImagePath}${blog.image}`}
                    alt={blog.title}
                    className="blog-image"
                  />
                  <div className="blog-content">
                    <p className="blog-date">
                      {new Date(blog.created_at).toLocaleDateString()}
                    </p>
                    <h3 className="ra-blog-title">{blog.title}</h3>
                    <p>
                      {blog.description.replace(/<[^>]+>/g, "").slice(0, 50)}...
                    </p>
                    <div className="ra-main-button-part">
                      <Link to={`/blog/${blog.id}`} className="read-more">
                        View More
                      </Link>
                      {/* <div className="blog-meta">
                        <span className="ra-meta-item">
                          <FaHeart /> {blog.likes || 0}
                        </span>
                        <span className="ra-meta-item">
                          <FaEye /> {blog.views || 0}
                        </span>
                        <span className="ra-meta-item">
                          <FaRegComment /> {blog.comments || 0}
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <Link to="/Blog" className="btn btn-primary all-blog-button">
              Read More
            </Link>
          </div>
        </div>
      </div>
      <div className="bhoj-slider-section">
        <div className="container">
          <h2 className="home-blog-title">
            PUJA/<span>HAVANS</span>
          </h2>
          <p className="ra-home-blog-description">
            At Jyotirvani, each ritual is guided by your horoscope to remove
            blockages and attract blessings.Our expert astrologers ensure
            authentic, result-driven ceremonies.Book your personalized puja
            today and feel the divine shift in your life.
          </p>
          <div className="bhoj-slider-container" ref={sliderRef}>
            {homams.map((item, index) => (
              <div key={index} className="bhoj-card">
                <img
                  src={item.image}
                  alt={item.pujaName}
                  className="bhoj-image"
                />
                <div className="bhoj-details">
                  <h3>{item.pujaName}</h3>
                  <h4 className="homam-category">
                    Puja/Havan for {item.category || "General"}
                  </h4>

                  {/* Truncated description */}
                  <div className="ra-bhoj-homam-description">
                    <div
                      dangerouslySetInnerHTML={createMarkup(
                        item.description?.length > 250
                          ? item.description.slice(0, 250) + "..."
                          : item.description,
                      )}
                    />
                    {item.description?.length > 250 && (
                      <Link to={`/puja-detail/${item.id}`}>
                        <button className="puja-view-more-btn">
                          View More
                        </button>
                      </Link>
                    )}
                  </div>

                  {/* Optional Price Display */}
                  {/* <p className="homam-price">₹ {item.price}</p> */}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link to="/Homan" className="btn btn-primary all-blog-button">
              View All Pujas
            </Link>
          </div>
        </div>
      </div>
      {/* image slider======= */} {/* vedio */}
      <HomeSlider />
      <AstrologerSlider />
     
      <Plan />
      <FaQ />
       <Testimonial />
      {/* Booking Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Book Your Astrological Session</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleFormSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                required
                placeholder="Enter your full name"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Date of Birth (DD/MM/YYYY)</Form.Label>
              <Form.Control
                type="text"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleInputChange}
                required
                placeholder="e.g., 15/08/1990"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Time of Birth (AM/PM)</Form.Label>
              <Form.Control
                type="text"
                name="timeOfBirth"
                value={formData.timeOfBirth}
                onChange={handleInputChange}
                required
                placeholder="e.g., 10:30 AM"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Place of Birth (City, State, Country)</Form.Label>
              <Form.Control
                type="text"
                name="placeOfBirth"
                value={formData.placeOfBirth}
                onChange={handleInputChange}
                required
                placeholder="e.g., Mumbai, Maharashtra, India"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Contact Number (WhatsApp preferred)</Form.Label>
              <Form.Control
                type="tel"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleInputChange}
                required
                placeholder="e.g., +91 9876543210"
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleModalClose}>
                Cancel
              </Button>
              <Button variant="primary" type="submit">
                Send to WhatsApp
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Home;
